import React, { Component, Fragment } from 'react';
import BudgetTable from 'modules/budget/components/budget-table/budget-table';
import BudgetedWidget from 'modules/budget/components/budgeted-widget';
import ActualWidget from 'modules/budget/components/actual-widget';
import BudgetInfoWidget from 'modules/budget/components/budget-info-widget';
import { inject, observer } from 'mobx-react';
import AddTransactionButton from 'modules/budget/components/budget-buttons/add-transaction-button';
import AddItemButton from 'modules/budget/components/budget-buttons/add-item-button';
import { Helmet } from 'react-helmet';

/**
 * Page with the budget table and status widgets
 */
@inject('store')
@observer
class BudgetPage extends Component {
    componentDidMount() {
        const { app, categories, budget } = this.props.store;
        categories.requestCategories();
        budget.requestBudget();
        app.setPageTitle('BUDGET.BUDGET.PAGE_TITLE');
    }

    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>Budget</title>
                </Helmet>
                <div className="container container-fixed-lg mt-3">
                    <div className="row">
                        <div className="col-md-3">
                            <AddTransactionButton />
                            <ActualWidget />
                        </div>
                        <div className="col-md-3">
                            <AddItemButton />
                            <BudgetedWidget />
                        </div>
                        <div className="col-md-6">
                            <BudgetInfoWidget />
                        </div>
                    </div>
                </div>
                <div className="container container-fixed-lg">
                    <div className="card">
                        <div className="table-responsive">
                            <BudgetTable />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default BudgetPage;


// WEBPACK FOOTER //
// ./src/modules/budget/pages/budget.js